import { Button } from "components";

interface SeeMoreButtonProps {
  isExpanded: boolean;
  onToggle: () => void;
}

export const SeeMoreButton = ({ isExpanded, onToggle }: SeeMoreButtonProps) => (
  <Button variant="link-teal" size="xs" mt="10px" onClick={onToggle}>
    {isExpanded ? "Show less" : "See more"}
  </Button>
);
